export default __webpack_public_path__ + "static/media/GAME GOAL.b8bd23e5.PNG";